// Types
import {
  ProviderConfiguration,
  ApexProviderType,
} from "../core/types/Provider";

// Providers
import ProviderFactory from "../core/ProviderFactory";
import ApexProvider from "../core/providers/apex/ApexProvider";

export default abstract class ApexModel {
  private static provider: ApexProvider = ProviderFactory.create(
    ApexProviderType.Parent,
    ProviderConfiguration.apex
  );
  private static hasAccessCached: boolean = null;

  public static hasAccess(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (ApexModel.hasAccessCached === null) {
        ApexModel.provider
          .hasAccess()
          .then((hasAccess) => {
            ApexModel.hasAccessCached = hasAccess;
            resolve(hasAccess);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        resolve(ApexModel.hasAccessCached);
      }
    });
  }
}
